import React, { useEffect, useState } from "react";
import { Document, Page, Text, View, Image, StyleSheet, PDFViewer, Font } from "@react-pdf/renderer";
import sunrise from "../utils/sunriseLogo.png";



// Define styles
// const styles = StyleSheet.create({
//   page: {
//     flexDirection: "column",
//     padding: 20,
//     fontSize: 10,
//     // fontFamily: "Figtree", // Apply Figtree font globally
//   },
//   header: {
//     flexDirection:'row',
//     justifyContent:'space-between',         
//     // textAlign: "center",
//     marginBottom: 10,
//   },
//   headerTitle: {
//     fontSize: '1.5rem', /* Equivalent to text-2xl */
//     fontWeight: 'bold' /* Equivalent to font-bold */,
//   },
//   logo: {
//     width: 100,
//     height: 50,
//     alignSelf: "center",
//   },
//   section: {
//     marginBottom: 10,
//   },
//   table: {
//     width: "100%",
//     borderWidth: 1,
//     borderColor: "black",
//     marginBottom: 10,
//   },
//   tableRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderColor: "black",
//   },
//   tableHeader: {
//     backgroundColor: "#f3f3f3",
//     fontWeight: "bold",
//   },
//   tableCell: {
//     flex: 1,
//     padding: 5,
//     textAlign: "center",
//     // fontFamily: 'Figtree', 
//   },
//   tableCellDescription: {
//     flex: 2, // Increased the flex value to give it more width
//     padding: 5,
//     textAlign: "center",
//   },
//   summary: {
//     textAlign: "right",
//     marginTop: 10,
//   },
//   terms: {
//     marginTop: 10,
//     borderTopWidth: 1,
//     paddingTop: 5,
//   },
//   footer: {
//     position: "absolute",
//     bottom: 20,
//     left: 0,
//     right: 0,
//     textAlign: "center",
//     fontSize: 10,
//   },
// });


const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
    fontSize: 10,
    // fontFamily: "Figtree", // Apply Figtree font globally
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5,
  },
  headerTitle: {
    fontSize: '1.5rem', /* Equivalent to text-2xl */
    fontWeight: 'bold' /* Equivalent to font-bold */,
  },
  logo: {
    width: 160,
    height: 100,
    alignSelf: "top",
  },
  section: {
    marginBottom: 5,
  },
  table: {
    marginTop: 10,
    width: "100%",
    borderWidth: 1,
    borderColor: "black",
    borderStyle: "solid",  // Ensure the border is solid
    marginBottom: 10,
    fontSize: 8,

  },



  tableRow: {
    flexDirection: "row",
    // borderBottomWidth: 1,

    borderColor: "black",
  },
  tableHeader: {
    backgroundColor: "#f3f3f3",
    fontWeight: "bold",
  },
  tableHeaderDescription: {
    flex: 4, // Increased flex value for more width
    padding: 5,
    // margin: 2,
    textAlign: "center",
    borderWidth: 1,
  },
  tableCell: {
    flex: 1, // Default flex for other columns
    padding: 5,
    textAlign: "center",
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: 1,
  },
  tableCellArticle: {
    flex: 3, // Increased flex value for more width
    padding: 5,
    textAlign: "center",
    borderWidth: 1,
  },
  summary: {
    textAlign: "right",
    marginTop: 10,
    width: "30%",
    marginLeft: "auto"
  },

  footer: {
    position: "absolute",
    bottom: 35,
    left: 20,
    right: 0,
    fontSize: 10,
    marginTop: 10,
    borderTopWidth: 1,
    paddingTop: 5,
  },

  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center',
    // color: 'grey',
    color: 'black',
  },
});

const fetchItemImage = async (itemFilePath) => {
  if (!itemFilePath) return ""; // Handle missing image

  // Extract file name from the full path
  const extractedFileName = itemFilePath.split("BONDTIME_PRODUCT_IMG\\")[1];

  // Construct the correct URL for the image
  let apiurl = `https://sunrise.dyndns-server.com:92/BONDTIME_PRODUCT_IMG/${extractedFileName}`
  console.log("apiurl ", apiurl)
  return apiurl;
  // return "https://res.cloudinary.com/demo/image/upload/v1312461204/sample.jpg"
};


// QuotationPDF Component
const QuotationPDF = ({ quotationData, selectedLead, formattedDate, productsInQuotationState, vatValue }) => {


  console.log('selectedLead >> in real pdf', selectedLead)
  console.log('leadProducts >> in real pdf', productsInQuotationState)
  console.log('leadProducts >> in real pdf vat', vatValue)

  const [isVatpresent, setIsVatpresent] = useState(null)

  useEffect(() => {

    if (productsInQuotationState) {
      if (vatValue > 0) {
        console.log("if vatPresent")
        setIsVatpresent(true)
      } else {
        console.log("else vatPresent")
        setIsVatpresent(false)
      }
    }


  }, [productsInQuotationState])

  return (
    <Document>
      {/* First Page */}
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>

          <View>
            <Text style={styles.headerTitle}>SUNRISE OASIS LIGHTING LLC</Text>
            <Text>Warehouse No.13, Al Kharman Street, Al Quoz Industrial Area 4</Text>
            <Text>info@sunriseoasislighting.com | 04-3236088</Text>
            <Text>www.sunriseoasislighting.com</Text>
            <Text>Date: {formattedDate}</Text>
          </View>

          <View>
            <Image src={sunrise} style={styles.logo} />
          </View>
        </View>

        {/* Customer & Project Details */}
        <View style={styles.section}>
          <Text style={styles.headerTitle}>Quotation</Text>
          <Text>To: {selectedLead?.lead_primarycontact}</Text>
          <Text>Company: {selectedLead?.lead_organization}</Text>
          <Text>Email: {selectedLead.lead_email ? selectedLead.lead_email : ""}</Text>
          <Text>Phone: {selectedLead.lead_phone}</Text>
          <Text>Date: {quotationData.date}??</Text>
        </View>

        {/* Products Table */}
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={styles.tableCell}>S.N</Text>
            <Text style={styles.tableCell}>Ref/Type</Text>
            <Text style={styles.tableCellArticle}>Article No</Text>
            <Text style={styles.tableHeaderDescription}>Description</Text>
            <Text style={styles.tableCell}>Prod Image</Text>
            <Text style={styles.tableCell}>Unit</Text>
            <Text style={styles.tableCell}>Qty</Text>
            <Text style={styles.tableCell}>Unit Price</Text>
            <Text style={styles.tableCell}>Amount</Text>
          </View>
          {/* {quotationData.items.map((item, index) => ( */}
          {productsInQuotationState?.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCell}>{index + 1}</Text>
              <Text style={styles.tableCell}>{item.itemCustRef || '--'}</Text>
              <Text style={styles.tableCellArticle}>{item.itemCode || '--'}</Text>
              <Text style={styles.tableHeaderDescription}>{item.itemDescription}</Text>


              {/* <Image style={styles.tableCell}

                src={{ uri: fetchItemImage(item.itemImage), method: 'GET', headers: {}, body: '', credentials: 'include' }} /> */}

              <Text style={styles.tableCell}>
                {" "}

                {/* <Image  src={{ uri: fetchItemImage(item.itemImage), method: 'GET', headers: {}, body: '', credentials: 'include' }} /> */}
              </Text>

              <Text style={styles.tableCell}>{item.itemUnit || '--'}</Text>
              <Text style={styles.tableCell}>{item.itemQuantity || '--'}</Text>
              <Text style={styles.tableCell}>{item.itemPrice || '--'}</Text>
              <Text style={styles.tableCell}>{item.itemAmount || '--'}</Text>
            </View>
          ))}
        </View>

        {/* Pricing Summary */}
        <View style={styles.summary}>

          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text>Total Value:</Text>
            <Text>
              {productsInQuotationState?.filter((item) => item.itemCustRef != "OPT")?.reduce((acc, curr) => {
                return acc + (curr.itemQuantity * curr.itemPrice);
              }, 0).toFixed(2)}
            </Text>
          </View>

          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text>VAT %</Text>
            <Text>{isVatpresent ? 5 : 0}</Text>
          </View>

          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text>VAT Amount: </Text>
            <Text>{isVatpresent ?
              (productsInQuotationState?.filter((item) => item.itemCustRef != "OPT")?.reduce((acc, curr) => {
                return acc + (curr.itemQuantity * curr.itemPrice);
              }, 0) * 0.05).toFixed(2)
              :
              0
            }</Text>

          </View>

          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text>Total Amount: </Text>
            <Text>{isVatpresent ?
              (
                productsInQuotationState?.filter((item) => item.itemCustRef != "OPT")?.reduce((acc, curr) => {
                  return acc + (curr.itemQuantity * curr.itemPrice);
                }, 0) +
                productsInQuotationState?.filter((item) => item.itemCustRef != "OPT")?.reduce((acc, curr) => {
                  return acc + (curr.itemQuantity * curr.itemPrice);
                }, 0) * 0.05
              ).toFixed(2)
              :
              productsInQuotationState?.filter((item) => item.itemCustRef != "OPT")?.reduce((acc, curr) => {
                return acc + (curr.itemQuantity * curr.itemPrice);
              }, 0).toFixed(2)
            }</Text>

          </View>


          {/* <Text>Air Freight Charges: {quotationData.freight.toFixed(2)}</Text>
          <Text>Special Discount 10%: {quotationData.discount.toFixed(2)}</Text>
          <Text style={{ fontWeight: "bold" }}>Net Value: {quotationData.netValue.toFixed(2)}</Text> */}
        </View>

        {/* Terms & Conditions */}
        <View style={styles.footer}>
          <Text style={{ fontWeight: "bold" }}>Terms & Conditions:</Text>
          <Text>1. Validity: This quotation is valid for {quotationData.validity} days.</Text>
          <Text>2. Delivery Time: Estimated delivery within {quotationData.deliveryTime} days.</Text>
          <Text>3. Payment Terms: {quotationData.paymentTerms}.</Text>
          <Text>4. Warranty: {quotationData.warranty} months from the date of delivery.</Text>
          <Text>5. Installation: {quotationData.installation}.</Text>
        </View>


        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          // `${pageNumber} / ${totalPages}`
          `Page ${pageNumber} of ${totalPages}`
        )} fixed />
      </Page>

      {/* Add more pages if needed */}
    </Document >
  );
};

export default QuotationPDF;